// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2voLk","validationTips":"StatementDescriptor_validationTips__DKvHV"};